<template>
    <page-message>
        <template #header>{{t('header')}}</template>
        <template #html>
            <div v-html="message"></div>
        </template>
        <template #cta>
            <router-link :to="{name:'home'}" class="btn btn-primary">{{$t('navigation.home')}}</router-link>
        </template>
    </page-message>
</template>

<script>

    import mixinView from "@/mixins/view";
    import PageMessage from "../../components/page/PageMessage";

    export default {
        name: "ViewsErrors400",
        components: {PageMessage},
        mixins: [mixinView],
        data() {

            return {
                t_path: "views.errors.400",
                email: process.env.VUE_APP_SUPPORT_EMAIL,

                message: null
            }
        },
        computed: {
            error() {

                return this.$route.params.error;
            },
            subject() {

                const path = this.error ? `views.errors.400.error.${this.error}.subject` : `views.errors.400.subject`;
                const translation = this.$t(path);

                if (translation != path) {

                    return translation;
                }

                return "";
            },
        },
        methods: {
            fetch() {

                const error = this.error;
                const email = `mailto:${this.email}`;
                const subject = this.subject;

                const message = error
                    ? this.t(`error.${error}.html`, {email, subject})
                    : this.t('html', {email, subject});

                this.message = message;
            }
        },
        mounted() {
            this.fetch();
        }
    }
</script>